"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = exports.AuthError = void 0;
var msal_1 = require("msal");
Object.defineProperty(exports, "AuthError", { enumerable: true, get: function () { return msal_1.AuthError; } });
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["ConsentRequired"] = "consent_required";
    ErrorCode["LoginRequired"] = "login_required";
    ErrorCode["InteractionRequired"] = "interaction_required";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
